type FilterData = {
  [key: string]: any;
};

export const useFilterSanitizer = (data: FilterData): { count: number; sanitized: FilterData } => {
  const sanitize = (value: any): any => {
    if (value === null || value === undefined) return undefined;
    if (Array.isArray(value)) return value.length ? value : undefined;
    if (typeof value === 'object') return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, sanitize(val)]).filter(([_, val]) => val !== undefined)
    );
    return Boolean(value) ? value : undefined;
  };

  const { location, sort, ...rest } = data;
  if (rest.catalog_filters?.sort && typeof rest.catalog_filters.sort === 'string') {
    // Split the sort string by commas to handle multiple sorting fields
    rest.catalog_filters.sort = rest.catalog_filters.sort.split(',').map((s: string) => {
      const [field, order] = s.split(':');
      return { field, order };
    });
  }
  
  const sanitizedData = sanitize(rest);

  // Handle the main sort field, converting it to array of objects as well
  const sanitizedSort = sort.split(',').map((s: string) => {
    const [sortField, sortOrder] = s.split(':');
    return { field: sortField, order: sortOrder };
  });

  const sanitized = {
    location,
    ...sanitizedData,
    sort: sanitizedSort  // Make sure 'sort' is also an array of objects
  };

  return {
    count: Object.keys(sanitizedData).length,
    sanitized,
  };
};
